/**
 * 
 * @param {Array} names 
 */
export const localStorageRemove = (names) => {
    names.forEach((n) => {
        localStorage.removeItem(n);
    });
};